import React, { useState, useEffect } from 'react';
import { FiBookOpen, FiPlus, FiTrash2, FiSave, FiCheck, FiAward, FiLayers } from 'react-icons/fi';
import ImageUploadField from './ImageUploadField';
import './AdminManage.css';

const STORAGE_KEY_FORMATIONS = 'iamar_formations_content';

const DEFAULT_FORMATIONS_DATA = {
  header: {
    title: "Programmes Exécutifs & Certifiants",
    subtitle: "Formations d'excellence dédiées aux cadres dirigeants, officiers et décideurs",
    bannerImage: ""
  },
  programs: [
    {
      id: 1,
      title: "Executive Master en Gouvernance Sécuritaire",
      duration: "12 Mois",
      format: "Hybride (Présentiel & Distanciel)",
      description: "Programme de haut niveau alliant géopolitique, analyse stratégique des risques et management des institutions sécuritaires.",
      image: ""
    },
    {
      id: 2,
      title: "Certificat d'Excellence en Cybersécurité Stratégique",
      duration: "4 Mois",
      format: "Week-ends intensifs",
      description: "Conçu pour préparer les RSSI, DSI et dirigeants aux menaces cyber et à la souveraineté numérique.",
      image: ""
    }
  ]
};

export default function AdminFormations() {
  const [data, setData] = useState(DEFAULT_FORMATIONS_DATA);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [newProgram, setNewProgram] = useState({
    title: '',
    duration: '',
    format: '',
    description: '',
    image: ''
  });

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY_FORMATIONS);
      if (saved) {
        setData(JSON.parse(saved));
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const handleSave = () => {
    localStorage.setItem(STORAGE_KEY_FORMATIONS, JSON.stringify(data));
    setSaveSuccess(true);
    setTimeout(() => setSaveSuccess(false), 2500);
  };

  const handleAddProgram = (e) => {
    e.preventDefault();
    if (!newProgram.title) return;
    setData(prev => ({
      ...prev,
      programs: [...prev.programs, { ...newProgram, id: Date.now() }]
    }));
    setNewProgram({ title: '', duration: '', format: '', description: '', image: '' });
    setShowAddForm(false);
  };

  const handleDeleteProgram = (id) => {
    setData(prev => ({
      ...prev,
      programs: prev.programs.filter(p => p.id !== id)
    }));
  };

  return (
    <div className="admin-manage-card" style={{ background: '#ffffff', borderRadius: 8, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: 16, marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: '1.4rem', color: '#1b1e4f', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 10 }}>
            <FiBookOpen /> Gestion des Formations & Programmes Exécutifs
          </h2>
          <p style={{ margin: '4px 0 0 0', color: '#64748b', fontSize: '0.88rem' }}>
            Configurez les cycles de formation, plaquettes et visuels des masters exécutifs
          </p>
        </div>

        <button
          onClick={handleSave}
          style={{
            background: saveSuccess ? '#10b981' : '#1b1e4f',
            color: 'white',
            border: 'none',
            padding: '9px 20px',
            borderRadius: 6,
            fontWeight: 600,
            fontSize: 13,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }}
        >
          {saveSuccess ? <FiCheck size={16} /> : <FiSave size={16} />}
          {saveSuccess ? 'Enregistré avec succès !' : 'Enregistrer les modifications'}
        </button>
      </div>

      {/* Header Info */}
      <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 20, marginBottom: 24, background: '#f8fafc' }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '1.1rem', color: '#1e293b' }}>
          En-tête de la page Formations
        </h3>

        <ImageUploadField
          label="Visuel d'en-tête (Upload image)"
          value={data.header.bannerImage}
          onChange={(url) => setData(prev => ({ ...prev, header: { ...prev.header, bannerImage: url } }))}
          helpText="Image d'illustration pour la page Formations Exécutives"
        />

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Titre de la section</label>
            <input
              type="text"
              value={data.header.title}
              onChange={(e) => setData(prev => ({ ...prev, header: { ...prev.header, title: e.target.value } }))}
              style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#334155', marginBottom: 6 }}>Sous-titre d'accroche</label>
            <input
              type="text"
              value={data.header.subtitle}
              onChange={(e) => setData(prev => ({ ...prev, header: { ...prev.header, subtitle: e.target.value } }))}
              style={{ width: '100%', padding: '9px 12px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
            />
          </div>
        </div>
      </div>

      {/* Programs List */}
      <div style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 20, background: '#ffffff' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: '1.1rem', color: '#1e293b' }}>
            Catalogues des Formations ({data.programs.length})
          </h3>
          <button
            onClick={() => setShowAddForm(true)}
            style={{
              background: '#1b1e4f',
              color: 'white',
              border: 'none',
              padding: '7px 14px',
              borderRadius: 6,
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }}
          >
            <FiPlus size={14} /> Ajouter une formation
          </button>
        </div>

        {showAddForm && (
          <form onSubmit={handleAddProgram} style={{ background: '#f8fafc', padding: 18, borderRadius: 8, border: '1px solid #cbd5e1', marginBottom: 20 }}>
            <h4 style={{ margin: '0 0 12px 0', fontSize: 14, color: '#1e293b' }}>Ajouter un nouveau cycle de formation</h4>
            <ImageUploadField
              label="Visuel ou plaquette de la formation (Upload image)"
              value={newProgram.image}
              onChange={(url) => setNewProgram(prev => ({ ...prev, image: url }))}
            />
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Titre du programme *</label>
                <input
                  type="text"
                  required
                  value={newProgram.title}
                  onChange={(e) => setNewProgram({ ...newProgram, title: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Durée (ex: 12 Mois, 6 Semaines)</label>
                <input
                  type="text"
                  value={newProgram.duration}
                  onChange={(e) => setNewProgram({ ...newProgram, duration: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Format (ex: Hybride, Présentiel)</label>
                <input
                  type="text"
                  value={newProgram.format}
                  onChange={(e) => setNewProgram({ ...newProgram, format: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
                />
              </div>
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Description détaillée</label>
              <textarea
                rows={3}
                value={newProgram.description}
                onChange={(e) => setNewProgram({ ...newProgram, description: e.target.value })}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 6, border: '1px solid #cbd5e1', fontSize: 13 }}
              />
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
              <button
                type="button"
                onClick={() => setShowAddForm(false)}
                style={{ background: '#e2e8f0', color: '#475569', border: 'none', padding: '7px 14px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
              >
                Annuler
              </button>
              <button
                type="submit"
                style={{ background: '#1b1e4f', color: 'white', border: 'none', padding: '7px 16px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
              >
                Ajouter
              </button>
            </div>
          </form>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {data.programs.map(p => (
            <div key={p.id} style={{ border: '1px solid #e2e8f0', borderRadius: 8, padding: 16, background: '#f8fafc', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                {p.image && (
                  <div style={{ height: 120, borderRadius: 6, overflow: 'hidden', marginBottom: 12 }}>
                    <img src={p.image} alt={p.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                )}
                <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                  {p.duration && <span style={{ fontSize: 11, background: '#e0f2fe', color: '#0369a1', padding: '2px 8px', borderRadius: 4, fontWeight: 600 }}>{p.duration}</span>}
                  {p.format && <span style={{ fontSize: 11, background: '#f1f5f9', color: '#475569', padding: '2px 8px', borderRadius: 4 }}>{p.format}</span>}
                </div>
                <h4 style={{ margin: '0 0 6px 0', fontSize: 14, fontWeight: 700, color: '#1e293b' }}>{p.title}</h4>
                <p style={{ margin: 0, fontSize: 12, color: '#64748b', lineHeight: 1.5 }}>{p.description}</p>
              </div>

              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 12, borderTop: '1px solid #e2e8f0', paddingTop: 8 }}>
                <button
                  onClick={() => handleDeleteProgram(p.id)}
                  style={{ background: '#fee2e2', color: '#dc2626', border: 'none', padding: '5px 10px', borderRadius: 4, fontSize: 11, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}
                >
                  <FiTrash2 size={12} /> Supprimer
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
